package uz.ferro.erp.util

import uz.ferro.erp.BASE_FILE_URL
import uz.ferro.erp.model.DataFile
import kotlin.js.Date

fun Int?.orZero(): Int = this ?: 0

fun Long?.orZero(): Long = this ?: 0L

fun Float?.orZero(): Float = this ?: 0f

fun String?.toIntOrZero(): Int = this?.toIntOrNull().orZero()

fun Double?.orZero(): Double = this ?: 0.0

fun String?.tryToDouble(): Double? {
    return this.orEmpty().removePrefix(".")
        .removeSuffix(".")
        .toDoubleOrNull()
}

fun DataFile?.sourceUrl(): String {
    if (this?.url.orEmpty().isBlank()) {
        return ""
    }
    return "$BASE_FILE_URL/api/file/download/${this!!.url}"
}

fun DataFile?.thumbnailUrl(size: Int): String {
    if (this?.url.orEmpty().isBlank()) {
        return ""
    }
    return this!!.url.thumbnailUrl(size)
}

fun String.thumbnailUrl(size: Int): String {
    return "$BASE_FILE_URL/api/file/thumbnail/$size/$this"
}

fun DataFile?.thumbnailSquareUrl(size: Int): String {
    if (this?.url.orEmpty().isBlank()) {
        return ""
    }
    return "$BASE_FILE_URL/api/file/thumbnail/square/$size/${this!!.url}"
}

fun Date?.formatDMY(): String {
    this ?: return ""
    val day = getDate().toString().let { if (it.length == 1) "0$it" else it }
    val year = getFullYear().toString()
    val month = (getMonth() + 1).toString().let { if (it.length == 1) "0$it" else it }
    return "$day.$month.$year"
}

fun Date?.formatDMYHm(): String {
    this ?: return ""
    val hour = getHours().toString().let { if (it.length == 1) "0$it" else it }
    val minutes = getMinutes().toString().let { if (it.length == 1) "0$it" else it }
    return "${formatDMY()} $hour:$minutes"
}

fun Date?.apiDate(): String {
    this ?: return ""
    val day = getDate().toString().let { if (it.length == 1) "0$it" else it }
    val year = getFullYear().toString()
    val month = (getMonth() + 1).toString().let { if (it.length == 1) "0$it" else it }

    val hour = getHours().toString().let { if (it.length == 1) "0$it" else it }
    val minutes = getMinutes().toString().let { if (it.length == 1) "0$it" else it }
    val seconds = getSeconds().toString().let { if (it.length == 1) "0$it" else it }
    return "$year-$month-${day}T$hour:$minutes:$seconds"
}

fun String?.onBlank(value: String?): String = if (this.isNullOrBlank()) value.orEmpty() else this

fun String?.onBlank(first: String?, second: String?): String {
    return this.onBlank(first.onBlank(second))
}